const localizedDigitMap = {
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9",
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9",
  "٫": ".",
  "٬": "",
};

const localizedDigitPattern = /[۰-۹٠-٩٫٬]/g;
const hasLocalizedDigitPattern = /[۰-۹٠-٩٫٬]/;

export const normalizeLocalizedNumbers = (value) =>
  String(value ?? "").replace(
    localizedDigitPattern,
    (digit) => localizedDigitMap[digit] ?? digit
  );

const shouldNormalizeElement = (element) => {
  if (!element || element.disabled || element.readOnly) return false;
  if (element.tagName === "TEXTAREA") return true;
  if (element.tagName !== "INPUT") return false;

  const type = (element.getAttribute("type") || "text").toLowerCase();
  return [
    "text",
    "number",
    "search",
    "tel",
    "url",
    "email",
    "password",
    "",
  ].includes(type);
};

const replaceElementValue = (element, text) => {
  const normalizedText = normalizeLocalizedNumbers(text);
  const currentValue = element.value || "";
  const start =
    typeof element.selectionStart === "number"
      ? element.selectionStart
      : currentValue.length;
  const end =
    typeof element.selectionEnd === "number" ? element.selectionEnd : start;

  element.value =
    currentValue.slice(0, start) + normalizedText + currentValue.slice(end);

  const nextPosition = start + normalizedText.length;
  try {
    element.setSelectionRange(nextPosition, nextPosition);
  } catch (error) {
    // Number inputs do not support selection ranges in some browsers.
  }

  element.dispatchEvent(new Event("input", { bubbles: true }));
};

export const installLocalizedNumberNormalizer = () => {
  if (typeof document === "undefined") return;
  if (window.__localizedNumberNormalizerInstalled) return;
  window.__localizedNumberNormalizerInstalled = true;

  document.addEventListener(
    "beforeinput",
    (event) => {
      if (!shouldNormalizeElement(event.target)) return;
      if (!event.data || !hasLocalizedDigitPattern.test(event.data)) return;

      event.preventDefault();
      replaceElementValue(event.target, event.data);
    },
    true
  );

  document.addEventListener(
    "paste",
    (event) => {
      if (!shouldNormalizeElement(event.target)) return;

      const pastedText = event.clipboardData?.getData("text");
      if (!pastedText || !hasLocalizedDigitPattern.test(pastedText)) return;

      event.preventDefault();
      replaceElementValue(event.target, pastedText);
    },
    true
  );
};
